import { useIntl } from 'react-intl'
import { LuxRichInputText } from '@lux/wardrobe-lib'
import { AttachmentProps } from '@/app/models/attachment'
import AddAttachment from '../../UI/AddAttachment/AddAttachment'
import { ResourcesService } from '@/app/services/ResourcesService'
import './ArticleAbstract.scss'
import {useEffect} from "react";

const ArticleAbstract = (props: {
    abstract: any
    setAbstract: (abstract: any) => void
    attachments: AttachmentProps[]
    setAttachments: (attachment: AttachmentProps[]) => void
}) => {
    const { abstract, setAbstract, attachments, setAttachments } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-resource-article-abstract'

    const onUploadAttachment = (files: any[]) => {
        setAttachments([
            ...attachments,
            ...files.map((file: any) => ({
                _id: file.id,
                url: file.url,
                file: file.file,
                name: file.file.name,
                ext: file.file.name?.split('.').pop() || file.file.type,
            }))
        ])
    }

    const onRemoveAttachment = (file: any) => {
        let tmpAttachments = [...attachments]
        let newAttachments = []

        tmpAttachments.map((item, index) => {
            if(!(item.name === file.name)) {
                newAttachments.push(item)
            }
        })

        setAttachments(newAttachments)
    }

    return (
        <div className={componentClass}>
            <label>
                <span className="label">
                    {intl.formatMessage({
                        id: 'modals.new_resource.label.abstract',
                        defaultMessage: 'Abstract',
                    })}
                </span>
            </label>
            <LuxRichInputText
                value={abstract}
                onChangeCallback={(value: any) => {
                    setAbstract(value)
                }}
                fileUploadUrl={ResourcesService.FROALA_UPLOAD_URL}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.main.info.rich.text.input.placeholder',
                    defaultMessage: 'Type here',
                })}
            />
            <AddAttachment
                showRemoveIcon
                disabled={false}
                showSplitFile={false}
                customEndpoint="resource"
                id={`article-${Math.random() * 100}`}
                onUpload={(file) => onUploadAttachment(file)}
                onRemove={(file) => onRemoveAttachment(file)}
                form={{ attachmentList: { value: attachments } }}
            />
        </div>
    )
}

export default ArticleAbstract
